import { useCallback, useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useBlocker, useLocation, useNavigate } from "react-router-dom";
import LoadingButton from "components/shared/LoadingButton";
import { Button } from "react-bootstrap";

const GoalTrackingWatcher = ({ handleSave, isLoading }) => {
  const { values, dirty, setFieldValue } = useFormikContext();
  const { hasUnsavedChanges } = values;
  const totalTracked = (values.goalTracking || []).reduce((total, tracking) => {
    if (!tracking.tracked) return total;
    return total + (tracking.count == null ? 1 : Number(tracking.count) || 0);
  }, 0);

  useEffect(() => {
    const trackings = values.goalTracking || [];
    const hasChanges = trackings.some((item) => item.dirty || (!item.id && item.tracked));
    setFieldValue("hasUnsavedChanges", hasChanges, false);
  }, [values.goalTracking])

 
  return (
    <div className="d-flex justify-content-center">
      <button
        type="button"
        className="d-flex align-items-center gap-2 justify-content-center preview-discharge-screen"
        disabled={!hasUnsavedChanges || totalTracked < 1 || isLoading}
        onClick={async () => {
          const saved = await handleSave(values.goalTracking);
          if (saved === true) {
            const savedTrackings = values.goalTracking.map((tracking) => ({ ...tracking, dirty: false }));
            await setFieldValue("goalTracking", savedTrackings, false);
            await setFieldValue("hasUnsavedChanges", false, false);
          }
        }}
      >
        Save Goal Tracking
      </button>
    </div>
  );
};

export default GoalTrackingWatcher;
